export default function SvgChevronDown(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg {...props} viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L4.29289 4.29289C4.68342 4.68342 5.31658 4.68342 5.70711 4.29289L9 1" stroke="currentColor" strokeWidth="2" />
        </svg>
    );
}
